export default {"src":"/_next/static/media/logo_no_text.0df0956c.svg","height":38,"width":21};